import FetchService from "./Shared/FetchService";
import AssignmentDomainService from "../Domain/Assignment/Assignment.service";
const ASSIGNMENT_URL = "/aviso/assignment";
let ENABLED_CACHE = null;
export default class AssignmentService {
    static enabled() {
        if (ENABLED_CACHE == null) {
            ENABLED_CACHE = FetchService.getSingleResponse(ASSIGNMENT_URL + "/enabled").then((data) => data.enabled);
        }
        return ENABLED_CACHE;
    }
    static getAssignments(courseSectionLmsId, pullFromLms) {
        return FetchService.getSingleResponse(ASSIGNMENT_URL + "/getAssignments", {
            courseSectionLmsId,
            pullFromLms,
        }).then((assignments) => 
        // @ts-expect-error - TS2571 - Object is of type 'unknown'.
        assignments.map(AssignmentDomainService.assignmentFromJson));
    }
    static getSubmissions(courseSectionLmsId, studentLmsId, pullFromLms) {
        return FetchService.getSingleResponse(ASSIGNMENT_URL + "/getSubmissions", {
            courseSectionLmsId,
            studentLmsId,
            pullFromLms,
        }).then((submissions) => 
        // @ts-expect-error - TS2571 - Object is of type 'unknown'.
        submissions.map(AssignmentDomainService.submissionFromJson));
    }
    static getGrades(transcriptCourseId, lmsAssignmentId, pullFromLms) {
        return FetchService.getSingleResponse(ASSIGNMENT_URL + "/getGrades", {
            transcriptCourseId,
            lmsAssignmentId,
            pullFromLms,
            // @ts-expect-error - TS2571 - Object is of type 'unknown'.
        }).then((grades) => grades.map(AssignmentDomainService.gradeFromJson));
    }
    static getSyncDates(assignments, submissions, grades) {
        const getLatestSyncDateFromArray = (arr) => {
            return arr.reduce((prev, curr) => {
                return prev.lastSyncDate > curr.lastSyncDate ? prev : curr;
            }, {});
        };
        const lastAssignmentSyncDate = getLatestSyncDateFromArray(assignments).lastSyncDate;
        const lastSubmissionSyncDate = getLatestSyncDateFromArray(submissions).lastSyncDate;
        const lastGradeSyncDate = getLatestSyncDateFromArray(grades).lastSyncDate;
        const lastOverallSyncDate = [
            lastAssignmentSyncDate,
            lastSubmissionSyncDate,
            lastGradeSyncDate,
        ].reduce((date1, date2) => {
            if (!date2) {
                return date1;
            }
            return date1 > date2 ? date1 : date2;
        }, lastAssignmentSyncDate);
        return {
            lastAssignmentSyncDate,
            lastSubmissionSyncDate,
            lastGradeSyncDate,
            lastOverallSyncDate,
        };
    }
    static getPersonLmsAssignments(search = {}, 
    // eslint-disable-next-line
    paging = {}) {
        return FetchService.getPagedResponse(ASSIGNMENT_URL + "/getPersonLmsAssignments", {
            courseSectionLmsId: search.courseSectionLmsId,
            personLmsId: search.personLmsId,
            lmsAssignmentIds: search.lmsAssignmentIds,
            transcriptCourseIds: search.transcriptCourseIds,
            lmsAssignmentName: search.lmsAssignmentName,
            createdDateFrom: search.createdDateFrom,
            createdDateTo: search.createdDateTo,
            dueDateFrom: search.dueDateFrom,
            dueDateTo: search.dueDateTo,
            submittedDateFrom: search.submittedDateFrom,
            submittedDateTo: search.submittedDateTo,
            minPointsPossible: search.minPointsPossible,
            maxPointsPossible: search.maxPointsPossible,
            status: search.status,
            itemStatusIds: search.itemStatusIds,
            minScore: search.minScore,
            maxScore: search.maxScore,
            minAvgScore: search.minAvgScore,
            maxAvgScore: search.maxAvgScore,
            isLate: search.isLate,
            pullFromLms: search.pullFromLms,
            sort: paging.sort,
            order: paging.order,
            max: paging.max,
            offset: paging.offset,
        }).then((result) => {
            // @ts-expect-error - TS2571 - Object is of type 'unknown'.
            const oldestSyncDate = result.data[0].oldestSyncDate;
            return Object.assign(Object.assign({}, result), { data: {
                    // @ts-expect-error - TS2571 - Object is of type 'unknown'.
                    dtos: result.data[0].dtos.map(AssignmentDomainService.personLmsAssignmentFromJson),
                    oldestSyncDate: oldestSyncDate && new Date(oldestSyncDate),
                } });
        });
    }
}
